export function updateObjectInCollection(collection, id, attributes) {
  const idx = collection.findIndex(item => item.id === id)

  if (idx === -1) {
    return collection
  }

  return [
    ...collection.slice(0, idx),
    Object.assign({}, collection[idx], attributes),
    ...collection.slice(idx + 1)
  ]
}



// WEBPACK FOOTER //
// ../src/utils/reduxHelpers.js